module.exports = __webpack_public_path__ + "external/owl.carousel/dist/assets/owl.video.play.png.png";


//////////////////
// WEBPACK FOOTER
// /var/www/smartbuy.ru/~/owl.carousel/dist/assets/owl.video.play.png
// module id = 496
// module chunks = 13